<template>
<div class="prevention-box-info card card-content-top" :class="{'has-tag': hasLocal}">
    <div class="card-top" :class="{'prevention-box-info-image': hasThumbnail}">
      <div v-if="hasThumbnail" class="card-img">
        <div>
          <img :src="article.getThumbnail()" width="660" height="416" alt="" loading="lazy" typeof="foaf:Image">
        </div>
      </div>
      <h3 class="card-title" >
        <a :href="article.getUrl()" v-html="$sanitize(article.getTitle())" :target="isExternalLink ? '_blank' : '_self'" :title="isExternalLink ? 'ouvrir dans une nouvelle page' :null"></a>
      </h3>
      <div v-if="!hasThumbnail" class="description" v-html="$sanitize(article.getDescription())" />
    </div>
    <p v-if="hasLocal" class="prevention-box-info-tag-area"><span class="tag">en région</span></p>
    <div class="card-bottom">
      <p class="card-date" v-if="article.getPublicationDate()">Publié le {{ article.getPublicationDate() }}</p>
      <p class="card-proposed-by" v-if="article.getSuggestedBy()">Proposé par {{ article.getSuggestedBy() }}</p>
      <a :href="article.getUrl()" class="link btn-arrow" :target="isExternalLink ? '_blank' : '_self'" :title="isExternalLink ? 'ouvrir dans une nouvelle page' : null"><span v-if="article.getButtonLabel()">{{ article.getButtonLabel() }}</span></a>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    article: {
      type: Object,
      default: () => ({}),
    },
    hasThumbnail: {
      type: Boolean,
      default: false,
    },
    isExternalLink: {
      type: Boolean,
      default: false,
    },
    hasLocal: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss">
.prevention-box-info{
    &-tag-area {
      position: absolute;
      right: 0;
      margin: 0;
      top: 0;
    }

    &-image {
      display: block;
    }
}
</style>
